import { DefaultTheme } from 'styled-components';

import { colors } from './colors';
import typography, { TypographyProps } from './typography';

declare module 'styled-components' {
  export interface DefaultTheme {
    typography: TypographyProps;
    colors: typeof colors;
  }
}

const theme: DefaultTheme = {
  typography,
  colors,
};

export { theme };

export default {
  theme,
};
